import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, PaginatedTable, PaginatedTableColumn, Section } from '@common/components';
import { formatDate } from '@common/utils';
import { GENETIC_COUNSELING_TRANSLATION } from '@modules/genetic-counseling/constants';
import { useReferralsTable } from '@modules/genetic-counseling/hooks';
import { PendingReferral, ReferralListItem, ReferralStatuses } from '@modules/genetic-counseling/types';
import BasicFilter from '../shared/BasicFilter/BasicFilter';

const Referrals: FC = () => {
  const { t } = useTranslation(GENETIC_COUNSELING_TRANSLATION);

  const {
    dataTable,
    commonColumns,
    pageSize,
    handleChangeSorting,
    handleChangePage,
    handleFilterChange,
    handleRowClick,
  } = useReferralsTable<PendingReferral>(ReferralStatuses.PENDING);

  const columns: Array<PaginatedTableColumn<ReferralListItem> | PaginatedTableColumn<PendingReferral>> = [
    {
      key: 'dateTime',
      label: t('table.referral_date'),
      render: (_column: PaginatedTableColumn<PendingReferral>, item: PendingReferral) => {
        return item.referralDateTime ? formatDate(item.referralDateTime, 'MM/dd/yyyy') : '--';
      },
      sort: true,
      width: '16%',
    },
    ...commonColumns,
  ];

  return (
    <Section title={t('referrals.section_title')}>
      <Box>
        <BasicFilter onFilterChange={handleFilterChange} />
        <PaginatedTable
          columns={columns}
          data={dataTable}
          isPaginated={false}
          onRowClick={handleRowClick}
          onSortingChange={handleChangeSorting}
          onPageChange={handleChangePage}
          pageSize={pageSize}
          rowClickable
        />
      </Box>
    </Section>
  );
};

export default Referrals;
